import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { generateCacheKey, withManualCache } from '@/utlility/cache-service';

const API_URL = process.env.NEXT_PUBLIC_API_URL;

// Async thunk to fetch SEO data
export const fetchSeoData = createAsyncThunk(
  'seo/fetchSeoData',
  async (payload, { rejectWithValue }) => {
    try {
      const url = `${API_URL}/api/seo-data`;
      const cacheKey = generateCacheKey(url, 'POST', payload);
      return await withManualCache(cacheKey, async () => {
        const response = await axios.post(url, payload);
        return response.data;
      });
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const seoSlice = createSlice({
  name: 'seo',
  initialState: {
    seoData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSeoData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSeoData.fulfilled, (state, action) => {
        state.loading = false;
        state.seoData = action.payload;
      })
      .addCase(fetchSeoData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch SEO data';
      });
  },
});

export default seoSlice.reducer;
